<template>
    <guest-layout>
        <div class="form-col mh-100">
            <div class="arrow-back d-none d-lg-block">
                <a href="https://helmbay.com"><span><i class="feather-chevron-left"></i></span>Back to website</a>
            </div>
<!--            <div class="register-content">-->
<!--                <span>Don't have an account? <a :href="route('register')" class="register-text">Register</a></span>-->
<!--            </div>-->
            <div class="web-form">
                <div class="title-col">
                    <h2>Login to your Account</h2>
                    <p>Type in your Email and Password</p>
                </div>
                <form class="form-style" @submit.prevent="submit">
                    <div class="form-group">
                        <label class="label-style" for="emailFld">Email address*</label>
                        <div class="input-col">
                            <input type="email" class="form-control input-style" id="email" v-model="form.email" autocomplete="off" />
                            <div v-if="form.errors.email" v-bind:style="styleObject">{{ form.errors.email }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="label-style" for="pwdFld">Password*</label>
                        <div class="input-col space-input">
                            <input v-bind:type="[showPassword ? 'text' : 'password']" id="password" type="password" class="form-control input-style" v-model="form.password" required autocomplete="current-password" />
                            <!-- <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control" placeholder="Password" v-model="form.password" id="password" type="password"> -->
                            <div v-if="form.errors.password" v-bind:style="styleObject">{{ form.errors.password }}</div>
                            <button type="button" class="show-hide-class" @click="showPassword = !showPassword">show</button>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="forgot-pwd-link">
                            <span>
                                <inertia-link v-if="canResetPassword" :href="route('password.request')">
                                    Forgot your password?
                                </inertia-link>
                            </span>
                        </div>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-style btn-primary w-100 btn-r-font" :disabled="form.processing"><span>Sign in</span></button>
                    </div>

                    <div class="form-group reg-form-group">
                        <div class="login-content text-center">
                            Don't have an account?
                            <inertia-link :href="route('register.providers')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                Register now!
                            </inertia-link>
                        </div>
                    </div>

                    <div class="form-group">
                        <a :href="route('auth.sso', {provider: 'github'})" class="btn btn-style btn-secondary w-100 btn-r-font">
                            <span>Login with Github</span>
                        </a>
                    </div>

                    <div class="form-group">
                        <a :href="route('auth.sso', {provider: 'google'})" class="btn btn-style btn-secondary w-100 btn-r-font">
                            <span>Login with Google</span>
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </guest-layout>
</template>
<script>
    import GuestLayout from "@/Layouts/GuestLayout";

        export default {
            components: {
                GuestLayout,
            },

            props: {
                canResetPassword: Boolean,
                status: String
            },

            data() {
                return {
                    form: this.$inertia.form({
                        email: '',
                        password: '',
                        remember: false
                    }),
                    styleObject: {
                        color: 'red',
                        fontSize: '15px'
                    },
                    showPassword: false,
                }
            },

            methods: {
                submit() {
                    this.form
                        .transform(data => ({
                            ... data,
                            remember: this.form.remember ? 'on' : ''
                        }))
                        .post(this.route('login'), {
                            onFinish: () => this.form.reset('password'),
                        })
                }
            }
        }
</script>
